
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schoolbox",
      function () {
        return require("private-next-pages/schoolbox.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/schoolbox"])
      });
    }
  